"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertyDescriptor = void 0;
function GetPropertyDescriptor(prototype, propertyKey) {
    const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyKey);
    if (!descriptor) {
        const parentPrototype = Object.getPrototypeOf(prototype);
        if (parentPrototype !== Object.prototype) {
            return GetPropertyDescriptor(parentPrototype, propertyKey);
        }
    }
    return descriptor;
}
exports.GetPropertyDescriptor = GetPropertyDescriptor;
